import React, { memo } from "react";
import PropTypes from "prop-types";

const Button = ({
  id,
  onClick,
  children,
  className = null,
  width,
  height,
  type,
  style,
  disabled = false,
}) => {
  const buttonStyle = {
    width: width || "",
    height: height || "46px",
  };

  return (
    <button
      id={id}
      type={type ? type : ""}
      onClick={onClick}
      disabled={disabled}
      className={` button-style ${className} px-2`}
      style={style ? style : buttonStyle}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
};

export default memo(Button);
